import { href } from "react-router-dom";

// Real data for Arun Kumar L's futuristic robotic portfolio
export const portfolioData = {
  hero: {
    name: "ARUN KUMAR L",
    role: "Computer Science & Engineering Student",
    subtitle: "AI-Augmented Full Stack Developer",
    tagline: "Turning ideas into delightful digital experiences"
  },

  about: {
    title: "About Me",
    description: "I'm Arunkumar, an AI-Augmented Full Stack Developer passionate about building scalable, intelligent, and user-centric web applications. My expertise lies in React, Next.js, TypeScript, Node.js, FastAPI, PostgreSQL, and modern UI/UX, with a strong focus on creating clean, performant, and production-ready solutions.\n\nCurrently, I'm working on enterprise-grade applications, contributing to features such as role-based access control (RBAC), dynamic workflows, AI-assisted systems, and interactive document experiences. I enjoy solving complex engineering challenges while designing intuitive user experiences that balance functionality and aesthetics.\n\nBeyond development, I have experience integrating AI capabilities using LLM APIs, designing interfaces in Figma, and building full-stack applications from concept to deployment. I'm always exploring emerging technologies, modern architectures, and AI-powered workflows to create software that delivers real-world impact.\n\nDriven by curiosity and continuous learning, I strive to build products that are not only technically robust but also meaningful, accessible, and enjoyable to use.",
    stats: [
      { label: "Certificates Earned", value: "10+" },
      { label: "Projects Completed", value: "20+" },
      { label: "Technologies Known", value: "15+" },
      { label: "Years Experience as a Freelancer", value: "2+" },
      // { label: "Languages Spoken", value: "Tamil & English" },
    ],
    certificates: [
      {
        id: 1,
        title: "Introduction to Machine Learning",
        issuer: "IIT Madras (NPTEL)",
        duration: "12 Weeks (Jan – Apr 2025)",
        icon: "🏆",
        description: "12-week comprehensive machine learning certification by NPTEL, IIT Madras. Mastered ML algorithms, supervised/unsupervised learning, classification, regression, and model evaluation metrics.",
        skills: ["Machine Learning", "Python", "Data Science", "Algorithms", "Scikit-Learn"]
      },
      {
        id: 2,
        title: "CCNA: Introduction to Networks",
        issuer: "Cisco & TNSDC (Tamil Nadu Skill Development Corporation)",
        duration: "Issued 04 March 2025",
        icon: "📜",
        description: "Cisco Certified Network Associate program covering network architectures, IP routing & switching, subnetting, network security fundamentals, and OSI model layers.",
        skills: ["Networking", "Cisco CCNA", "IP Subnetting", "Routing & Switching", "Network Security"]
      },
      {
        id: 3,
        title: "AI & Data Analytics Internship (Skills4Future Program)",
        issuer: "AICTE, Shell & Edunet Foundation",
        duration: "4 Weeks (25 Aug – 25 Sep 2025)",
        icon: "🤖",
        description: "Specialized internship under the Skills4Future program focusing on AI modeling, data analysis, exploratory data visualization, and machine learning pipeline integration.",
        skills: ["Artificial Intelligence", "Data Analytics", "Python", "Pandas", "Data Visualization"]
      },
      {
        id: 4,
        title: "Front-End Web Development Internship (IBMSKILLBUILD Program)",
        issuer: "AICTE, IBM & Edunet Foundation",
        duration: "6 Weeks (21 Aug – 30 Sep 2025)",
        icon: "💻",
        description: "Hands-on front-end web development internship under IBM SkillBuild. Developed responsive web applications, modern UI components, and accessible web interfaces.",
        skills: ["React.js", "HTML5/CSS3", "JavaScript", "Responsive Design", "Web Architecture"]
      },
      {
        id: 5,
        title: "TripXplo – Frontend Development Internship",
        issuer: "Tripmilestone Tours Pvt Ltd",
        duration: "4 Months (01 Apr – 04 Aug 2025)",
        icon: "🚀",
        description: "Built the TripXplo frontend application featuring real-time travel CRM interfaces, interactive booking dashboards, dynamic route planning, and responsive customer flows.",
        skills: ["React.js", "Frontend Engineering", "UI/UX Components", "State Management", "REST APIs"]
      },
      {
        id: 6,
        title: "Full Stack Development Master Class",
        issuer: "NoviTech R&D Pvt Ltd",
        duration: "30 Days (27 May – 25 June 2024)",
        icon: "⚡",
        description: "Intensive full-stack masterclass covering React component architecture, Node.js RESTful API design, database modeling, and end-to-end full-stack deployment.",
        skills: ["Full Stack", "React.js", "Node.js", "Express.js", "Git & Version Control"]
      },
      {
        id: 7,
        title: "Full Stack Web Development Internship",
        issuer: "CodeAlpha",
        duration: "30 Days (20 July – 20 Aug 2025)",
        icon: "🛠️",
        description: "Developed real-world full-stack web applications featuring secure authentication, RESTful APIs, database connectivity, and modern responsive user interfaces.",
        skills: ["React.js", "Node.js", "MongoDB", "Express", "API Integration"]
      },
      {
        id: 8,
        title: "Introduction to Front-End Development",
        issuer: "Coursera (Meta)",
        duration: "Completed 16 Sep 2025",
        icon: "🌐",
        description: "Meta professional certification covering core web technologies, modern HTML5, CSS layout techniques, JavaScript fundamentals, and modern web application structure.",
        skills: ["HTML5", "CSS3", "JavaScript", "Front-End Architecture", "Meta Certification"]
      },
      {
        id: 9,
        title: "Getting Started with Front-End & Web Development",
        issuer: "Coursera (IBM)",
        duration: "Completed 12 Sep 2025",
        icon: "⚙️",
        description: "IBM professional certification covering web development standards, client-server communications, version control workflows, and front-end tooling.",
        skills: ["Web Development", "Cloud Concepts", "Git", "IBM Certification"]
      },
      {
        id: 10,
        title: "Java with Spring Boot Level-2 Hackathon Certificate",
        issuer: "Naan Mudhalvan (NM)",
        duration: "November 2025",
        icon: "🏆",
        description: "Level-2 Hackathon certification for building scalable enterprise backend microservices using Java and Spring Boot framework under the Naan Mudhalvan initiative.",
        skills: ["Java", "Spring Boot", "REST Microservices", "Backend Logic", "Hackathon"]
      },
      {
        id: 11,
        title: "Startup Hackathon 3.0 – Participation Certificate",
        issuer: "Mitraroop Foundation",
        duration: "21 December 2025",
        icon: "💡",
        description: "Recognized for innovative prototype design and rapid product MVP development during Startup Hackathon 3.0 organized by Mitraroop Foundation.",
        skills: ["Product Prototyping", "MVP Development", "Hackathon", "Problem Solving", "Innovation"]
      },
      {
        id: 12,
        title: "Flutter Development Master Class Webinar",
        issuer: "Flutter Community",
        duration: "3 Days (23 May – 25 May 2024)",
        icon: "📱",
        description: "Cross-platform mobile app development webinar covering Dart programming language, widget tree lifecycle, and mobile app UI layout design.",
        skills: ["Flutter", "Dart", "Mobile App Development", "Cross-Platform UI"]
      }
    ]
  },

  projects: [
    {
      id: 30,
      title: "Aura360",
      description: "Life Personal App: Daily Tracker, Money management, skincare track, fitness, notes, fashion, saved.",
      technologies: ["React", "AI", "Tailwind", "Fullstack"],
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://aura360.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Aura360",
      status: "Live"
    },
    {
      id: 31,
      title: "Wiper",
      description: "Windows app cleaner and storage optimization tool to reclaim disk space and speed up systems.",
      technologies: ["C++", "Windows API", "System Utility"],
      image: "https://images.unsplash.com/photo-1563770660941-20978e870e26?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Wiper",
      status: "Devlopment"
    },
    {
      id: 32,
      title: "ApiManagement",
      description: "All-in-one API key management, testing, and secure credential storage dashboard.",
      technologies: ["React", "Node.js", "Cryptography", "Security"],
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://ak-apis.vercel.app/",
      githubUrl: "https://github.com/ARUN-L-KUMAR/API-Management",
      status: "Development"
    },
    {
      id: 33,
      title: "Gone",
      description: "AI Personal Task Assistant that automates workflow routing, context matching, and direct messaging.",
      technologies: ["Next.js", "OpenAI SDK", "Agentic Workflow"],
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://personal-task-automation.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/personal-task-automation",
      status: "Live"
    },
    {
      id: 20,
      title: "Market",
      description: "Realistic e-commerce platform with admin panel, real-time updates, and production-level UI.",
      technologies: ["React", "Node", "MongoDB", "Socket.io", "Fullstack", "#fullstack"],
      image: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://akmarket.vercel.app/",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Market",
      status: "Live"
    },
    {
      id: 4,
      title: "Frontend Mini Projects Collection",
      description: "A comprehensive collection of 10+ mini frontend projects including E-Commerce interfaces, Blog layouts, Weather Apps, To-Do applications, and more.",
      technologies: ["HTML", "CSS", "JavaScript", "React"],
      image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://frontend-basic-projects-xi.vercel.app/",
      githubUrl: "https://github.com/ARUN-L-KUMAR/frontend-basic-projects",
      status: "Live"
    },
    {
      id: 22,
      title: "Crops Disease Detection",
      description: "AI model that identifies crop diseases from leaf images to help farmers.",
      technologies: ["AI", "Agriculture", "ML", "#AI", "#internship"],
      image: "https://images.unsplash.com/photo-1500651230702-0e2d8a49d4ad?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/AICTE-Sustainable-Agriculture",
      status: "Live"
    },
    {
      id: 21,
      title: "Emotion Detection",
      description: "AI system that detects and classifies human emotions using image input.",
      technologies: ["AI", "Deep Learning", "#AI"],
      image: "https://images.unsplash.com/photo-1555255707-c07966088b7b?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Emotion-Detection",
      status: "Live"
    },
    {
      id: 17,
      title: "Codealpha_Communication_app",
      description: "Real-time chat and communication platform.",
      technologies: ["MERN", "Socket.io", "Fullstack", "#fullstack", "#internship"],
      image: "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://codealpha-communication.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Communication_app",
      status: "Live"
    },
    {
      id: 18,
      title: "Codealpha_Project_Management",
      description: "Project and task management tool with user dashboard.",
      technologies: ["MERN", "Fullstack", "#fullstack", "#internship"],
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://codealpha-project-management.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Project_Management",
      status: "Live"
    },
    {
      id: 19,
      title: "Codealpha_Ecommerce_store",
      description: "E-commerce store with product listing, cart, and checkout functionality.",
      technologies: ["MERN", "Fullstack", "#fullstack", "#internship"],
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://codealpha-ecommerce-store.onrender.com",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Ecommerce_store",
      status: "Live"
    },
    {
      id: 16,
      title: "Codealpha_Social_Media",
      description: "Social media app with post creation, likes, comments, and follow system.",
      technologies: ["MERN", "Fullstack", "#fullstack", "#internship"],
      image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Social_Media",
      status: "Live"
    },
    {
      id: 12,
      title: "Online-Quiz-Application",
      description: "Interactive online quiz app with real-time score tracking and dynamic questions.",
      technologies: ["React", "Frontend", "#frontend"],
      image: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://quizplannerhub.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/AICTE-Frontend",
      status: "Live"
    },
    {
      id: 13,
      title: "Smart-Study-Planner",
      description: "Smart planner that helps students manage tasks, deadlines, and study schedules.",
      technologies: ["React", "Frontend", "#frontend"],
      image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://studyplannerhub.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/AICTE-Frontend",
      status: "Live"
    },
    {
      id: 14,
      title: "Personal_CRM",
      description: "Personal CRM system to manage daily contacts, reminders, and productivity tasks.",
      technologies: ["Dashboard App", "Frontend", "#frontend"],
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Personal_CRM",
      status: "Live"
    },
    {
      id: 5,
      title: "Java With Spring Boot",
      description: "For building scalable and efficient backend services and REST APIs.",
      technologies: ["Java", "Spring Boot", "Rest API"],
      image: "/javaspringimg.png",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/NM-Springboot-1",
      status: "Live"
    },
    {
      id: 23,
      title: "AICTE – Sustainable Agriculture",
      description: "Internship project focused on sustainable agriculture with AI for crop disease detection.",
      technologies: ["Internship", "AI", "Agriculture", "#internship", "#AI"],
      image: "https://images.unsplash.com/photo-1500651230702-0e2d8a49d4ad?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/AICTE-Sustainable-Agriculture",
      status: "Live"
    },
    {
      id: 6,
      title: "Data Science & Analysis Basics",
      description: "Exploratory data analysis using Python, Pandas, and Matplotlib.",
      technologies: ["Python", "Pandas", "Matplotlib"],
      image: "/Data-Science-Basics.png",
      demoUrl: "",
      githubUrl: "https://github.com/ARUN-L-KUMAR/DATA-SCIENCE-",
      status: "Live"
    },
    {
      id: 7,
      title: "UI & UX Design",
      description: "Designed interfaces including Instagram feed, WhatsApp tabs, e-commerce style guides, color palettes, moodboards, and wireframes for food delivery apps.",
      technologies: ["Figma", "UI Design", "Wireframing", "Color", "Moodboard"],
      image: "/UIUX.avif",
      demoUrl: "https://www.figma.com/team_invite/redeem/c0SyKmzUp8Wn8BDzefcSYD",
      githubUrl: "",
      status: "Live"
    },
    {
      id: 8,
      title: "Agritech App UI",
      description: "Modern UI design for an agriculture technology platform",
      technologies: ["Figma", "UI Design", "Wireframing"],
      image: "/farmzi.jpeg",
      demoUrl: "https://www.figma.com/design/ia5hbZcONSSHvNDloimV6y/Farmzi-UI?node-id=0-1&t=VryHfCWMPQKQqgQO-1",
      githubUrl: "",
      status: "Live"
    },
    {
      id: 9,
      title: "CommunityCoin DApp",
      description: "A decentralized application for community token management on Ethereum Sepolia testnet.",
      technologies: ["Solidity", "Ethers.js", "Hardhat"],
      image: "/Communitycoin.png",
      demoUrl: "https://communitycoin.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Community-Coin-Funding-DApp",
      status: "Live"
    },
    {
      id: 10,
      title: "Artisanchain",
      description: "A DApp for certifying and tracking provenance of artisanal goods on Ethereum. Features NFT minting, IPFS storage, and a marketplace for local artisans.",
      technologies: ["Solidity", "Ethers.js", "Hardhat", "IPFS"],
      image: "/Artisanalchian.png",
      demoUrl: "https://artisanalchain.vercel.app/",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Artisanal-Chain-DApp",
      status: "Live"
    },
    {
      id: 11,
      title: "EventDapp",
      description: "A blockchain-based event ticketing DApp with NFT tickets, decentralized verification, and a modern React frontend.",
      technologies: ["Solidity", "Ethers.js", "Hardhat", "NFT"],
      image: "/Eventdapp.png",
      demoUrl: "https://evt-tix.vercel.app",
      githubUrl: "https://github.com/ARUN-L-KUMAR/Event-Ticket-DApp",
      status: "Live"
    }
  ],

  skills: {
    categories: [
      {
        title: "Frontend Development",
        skills: [
          { name: "HTML & CSS", level: 70 },
          { name: "JavaScript", level: 50 },
          { name: "React.js", level: 45 },
          { name: "Tailwind CSS", level: 50 },
          { name: "Responsive Design", level: 60 },
          { name: "Flutter", level: 30 }
        ]
      },
      {
        title: "Backend & Full Stack",
        skills: [
          { name: "Node.js", level: 30 },
          { name: "Spring Boot(Java)", level: 30 },
          { name: "Supabase", level: 35 },
          { name: "PostMan", level: 35 },
          { name: "SQL", level: 50 },
          { name: "API & RESTAPI", level: 30 },
          { name: "Prompt Engineering", level: 45 }
        ]
      },
      {
        title: "Tools & Platforms",
        skills: [
          { name: "VS Code", level: 80 },
          { name: "Cursor", level: 70 },
          { name: "IntelliJ", level: 60 },
          { name: "Windsurf", level: 50 },
          { name: "Git & GitHub", level: 75 },
          { name: "Vercel", level: 70 },
          { name: "Postman", level: 60 },
          { name: "Supabase", level: 50 },
          { name: "Figma", level: 60 },
          { name: "Remix-Solidity", level: 40 },
          { name: "Colab", level: 50 }
        ]
      },
      {
        title: "Others",
        skills: [
          { name: "UI & UX Design", level: 45 },
          { name: "Solidity", level: 45 },
          { name: "Ethereum-Sepolia Testnet", level: 40 },
          { name: "Python", level: 65 },
          { name: "Pandas", level: 45 },
          { name: "NumPy", level: 45 },
          { name: "OpenAI API", level: 40 }
        ]
      },
      {
        title: "Soft Skills",
        skills: [
          { name: "Team collaboration", level: 80 },
          { name: "Self-learning", level: 85 },
          { name: "UI intuition", level: 75 },
          { name: "Creative problem-solving", level: 80 }
        ]
      }
    ]
  },

  internships: [
    {
      id: 1,
      company: "CodeAlpha",
      duration: "20th July 2025 – 20th August 2025",
      projects: [

        {
          title: "Codealpha Communication App",
          description: "Real-time chat application with group messaging, file sharing, and video calling capabilities.",
          technologies: ["React", "Node.js", "Socket.io", "WebRTC", "MongoDB"],
          githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Communication_app",
          demoUrl: "https://codealpha-communication.vercel.app",
          status: "Live"
        },
        {
          title: "Codealpha Project Management",
          description: "Comprehensive project management tool with task tracking, team collaboration, and progress analytics.",
          technologies: ["MERN Stack", "Chart.js", "Material-UI", "Express.js"],
          githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Project_Management",
          demoUrl: "https://codealpha-project-management.vercel.app",
          status: "Live"
        },
        {
          title: "Codealpha Ecommerce Store",
          description: "Full-featured e-commerce platform with payment integration, inventory management, and admin dashboard.",
          technologies: ["MERN Stack", "Stripe API", "Redux", "Tailwind CSS"],
          githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Ecommerce_store",
          demoUrl: "https://codealpha-ecommerce-store.onrender.com",
          status: "Live"
        }, {
          title: "Codealpha Social Media",
          description: "Full-stack social media platform with user authentication, posts, likes, comments, and real-time messaging features.",
          technologies: ["MERN Stack", "Socket.io", "JWT", "Cloudinary"],
          githubUrl: "https://github.com/ARUN-L-KUMAR/Codealpha_Social_Media",
          demoUrl: "",
          status: "Live"
        }
      ],
      badge: "CodeAlpha",
      image: "/codealpha.jpeg"
    },
    {
      id: 2,
      company: "Edunet Foundation (AICTE Internship)",
      duration: "April 2025 – May 2025",
      projects: [
        {
          title: "Crops Disease Detection (AICTE – Sustainable Agriculture)",
          description: "AI-powered crop disease detection system using computer vision and machine learning to help farmers identify plant diseases early.",
          technologies: ["Python", "TensorFlow", "OpenCV", "Flask", "React"],
          githubUrl: "https://github.com/ARUN-L-KUMAR/AICTE-Sustainable-Agriculture",
          demoUrl: "",
          status: "Live"
        },
        {
          title: "Movie Review Platform (AICTE – Web Development)",
          description: "Dynamic web platform for movie reviews with user ratings, comments, and personalized recommendations.",
          technologies: ["MERN Stack", "Express.js", "MongoDB", "JWT", "Tailwind CSS"],
          githubUrl: "https://github.com/ARUN-L-KUMAR/movie-review-platform",
          demoUrl: "https://cinehub-in.vercel.app",
          status: "Live"
        }
      ],
      badge: "AICTE",
      image: "./edunet.jpeg"
    }
    ,
    {
      id: 3,
      company: "TripXplo",
      duration: "2024 – 2025",
      projects: [
        {
          title: "TripXplo Travel Tech Solutions",
          description: "Worked as a Frontend Developer and later as an AI Agent Developer for TripXplo, a travel technology startup. Designed the hotel-side management dashboard for the TripXplo platform (similar to Agoda's YCS). Created intuitive interfaces for modules like Inventory, Accounts, Rooms, and Booking Management. Developed the Quotation Calculator UI and expanded it into a B2B CRM travel solution with features like lead management, quotation generation, and booking workflows. Integrated AI Agents using OpenAI SDK, CrewAI, and Next.js to automate travel-related operations and planning.",
          technologies: ["Figma", "React.js", "Next.js", "Supabase", "OpenAI API", "CrewAI", "LangGraph"],
          githubUrl: "https://github.com/ARUN-L-KUMAR?tab=repositories",
          demoUrl: "",
          status: "Live"
        }
      ],
      badge: "#TripXplo",
      image: "./tripxplo_logo.jpeg"
    }
  ],

  contact: {
    title: "Initialize Contact Protocol",
    subtitle: "Feel free to reach out for collaborations or just a friendly hello!",
    email: "arunkumar582004@gmail.com",
    phone: "+91 8778929845",
    location: "Kanchipuram, Tamil Nadu, India",
    social: [
      { platform: "GitHub", url: "https://github.com/ARUN-L-KUMAR", icon: "github" },
      { platform: "LinkedIn", url: "https://linkedin.com/in/arun-kumar-l", icon: "linkedin" },
      { platform: "Portfolio", url: "https://a-k-l.vercel.app/", icon: "link" }
    ]
  },

  connect: {
    title: "Connect With Me",
    subtitle: "Establish direct link nodes with my digital interfaces",
    links: [
      {
        id: 1,
        platform: "GitHub",
        title: "GitHub Profile",
        url: "https://github.com/ARUN-L-KUMAR",
        coverImage: "/github.png",
        description: "Explore my open-source code repositories, personal contributions, and automated development workflow pipelines.",
        status: "Online",
        badge: "Code Hub",
        buttonText: "Link Codebase",
        icon: "github"
      },
      {
        id: 2,
        platform: "LinkedIn",
        title: "LinkedIn Profile",
        url: "https://linkedin.com/in/arun-l-kumar",
        coverImage: "/linkedin.png",
        description: "Connect with me professionally, view my career path, research publications, and tech networking posts.",
        status: "Active",
        badge: "Professional",
        buttonText: "Establish Link",
        icon: "linkedin"
      },
      {
        id: 3,
        platform: "Figma",
        title: "Figma Profile",
        url: "https://www.figma.com/design/ia5hbZcONSSHvNDloimV6y/Farmzi-UI",
        coverImage: "/figma.png",
        description: "Inspect my interactive user experience mockups, interface designs, wireframes, and prototypes.",
        status: "Online",
        badge: "UI/UX Canvas",
        buttonText: "Inspect Layout",
        icon: "figma"
      },
      {
        id: 4,
        platform: "Instagram",
        title: "Instagram Profile",
        url: "https://instagram.com/badvibes_arun",
        coverImage: "/cover/instagram.png",
        description: "Follow my personal creative highlights, technical setups, developer updates, and daily snapshots.",
        status: "Active",
        badge: "Social Stream",
        buttonText: "View Feed",
        icon: "instagram"
      },
      {
        id: 5,
        platform: "WhatsApp",
        title: "WhatsApp Chat",
        url: "https://wa.me/918778929845",
        coverImage: "/cover/whatsapp.png",
        description: "Transmit immediate messages or pings directly to my cell for fast collaborations and project consultation.",
        status: "Direct",
        badge: "Direct Line",
        buttonText: "Transmit Ping",
        icon: "whatsapp"
      },
      {
        id: 6,
        platform: "Discord",
        title: "Discord Server / DM",
        url: "https://discord.com/users/badvibes_arun",
        coverImage: "/cover/discord.png",
        description: "Establish link with my Discord terminal for instant chat, direct pings, code debugs, or design critiques.",
        status: "Online",
        badge: "Comm Node",
        buttonText: "Connect Node",
        icon: "discord"
      }
    ]
  },

  hackathons: [
    {
      id: 1,
      title: "Cloud-Storage (clone of G-Drive)",
      description: "Google Drive clone built for the GUVI Hackathon featuring secure cloud storage nodes.",
      technologies: ["MERN", "AWS", "Hackathon"],
      image: "https://images.unsplash.com/photo-1600132806370-bf17e65e942f?auto=format&fit=crop&w=800&q=80",
      demoUrl: "https://c-drive.vercel.app/",
      githubUrl: "https://github.com/ARUN-L-KUMAR/googledrive-fullstack.git",
      status: "GUVI Hackathon Project"
    },
    {
      id: 2,
      title: "LearnSphere",
      description: "Comprehensive education management platform built for the Odoo Hackathon.",
      technologies: ["Python", "Odoo", "Hackathon"],
      image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "",
      status: "Odoo Hackathon"
    },
    {
      id: 3,
      title: "Grocery-Comparison",
      description: "Real-time grocery price comparisons and list optimizer built for the ITC Hackathon.",
      technologies: ["React", "Python", "ITC SDK", "Hackathon"],
      image: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "",
      status: "ITC Hackathon"
    },
    {
      id: 4,
      title: "HealthCare-Appointment-System",
      description: "Scalable doctor-patient portal and appointment scheduler built for the NM Hackathon.",
      technologies: ["Java", "Spring Boot", "Rest API", "Hackathon"],
      image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=800&q=80",
      demoUrl: "",
      githubUrl: "",
      status: "NM Hackathon"
    }
  ],

  portfolioVersions: [
    {
      id: 1,
      title: "Portfolio v1.0",
      subtitle: "2024–2025 • Foundation",
      description:
        "My first portfolio focused on frontend fundamentals, UI experiments, and personal projects. This version marked the beginning of my development journey.",
      coverImage: "/cover/v1.png",
      url: "https://arun-l-kumar.vercel.app",
      badge: "v1.0",
      status: "Archived"
    },
    {
      id: 2,
      title: "Portfolio v2.0",
      subtitle: "2025–2026 • Current",
      description:
        "A cyberpunk-inspired interactive portfolio showcasing full-stack projects, company experience, hackathons, and modern UI/UX design.",
      coverImage: "/cover/v2.png",
      url: "https://ak-live.vercel.app",
      badge: "v2.0",
      status: "Live"
    },
    {
      id: 3,
      title: "Portfolio v3.0",
      subtitle: "2026–2027 • Next Generation",
      description:
        "Currently in development. A next-generation portfolio featuring immersive 3D interactions, advanced animations, AI-powered experiences, and cinematic storytelling.",
      coverImage: "/cover/3d.png",
      url: "https://a-k-l.vercel.app",
      badge: "Coming Soon",
      status: "Development"
    }
  ]
};

// Animation sequences for robotic effects
export const roboticAnimations = {
  scanningLines: {
    duration: 3000,
    interval: 5000
  },
  holographicGrid: {
    opacity: 0.1,
    speed: 0.5
  },
  mechanicalTransitions: {
    stagger: 100,
    duration: 600
  }
};

// Color scheme for cyberpunk theme
export const cyberTheme = {
  primary: '#00FFD1',
  secondary: '#6FD2C0',
  accent: '#00D4FF',
  background: '#000000',
  surface: '#121212',
  text: '#FFFFFF',
  textSecondary: 'rgba(255, 255, 255, 0.85)',
  textMuted: '#4D4D4D',
  border: 'rgba(255, 255, 255, 0.25)'
};